import { Flex } from "@chakra-ui/react";
import { Button, ErrorMessage, Input, Link, Typography } from "@sgi/gravity";
import { ChangeEvent, useCallback, useState, KeyboardEvent, useEffect } from "react";
import { usePhoneFactorSetupProxy } from "../Custom Hooks/usePhoneFactorSetupProxy";

export default function ConfirmPhoneFactor() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");

  const {
    sendCodeAction,
    callMeAction,
    verifyCodeAction,
    cancelAction,
    sendANewCodeAction,
    pageError,
    verificationCodeError,
  } = usePhoneFactorSetupProxy({ phoneNumber, verificationCode });

  const [phoneMethod, setPhoneMethod] = useState('');

  useEffect(() => {
    const savedPhoneNumber = sessionStorage.getItem('authex-registration-signup-mfa-phone-number');
    const savedPhoneMethod = sessionStorage.getItem('authex-registration-signup-mfa-phone-method');
    if (savedPhoneNumber == null || savedPhoneMethod == null) return;
    setPhoneNumber(savedPhoneNumber);
    setPhoneMethod(savedPhoneMethod);
    if (savedPhoneMethod === 'text') {
      setTimeout(() => sendCodeAction.act(), 100);
    } else if (savedPhoneMethod === 'call') {
      setTimeout(() => callMeAction.act(), 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onVerifyChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.target.value),
    []
  );
  const onVerifyKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") verifyCodeAction.act();
    },
    [verifyCodeAction]
  );

  if (phoneMethod === 'text') {
    return (
      <Flex direction="column" maxW={468} minH="100vh" justifyContent="center" mx="auto" data-testid="confirm-phone-factor-text-test">
        <Typography variant="h2">
          Enter Verification Code
        </Typography>
        <Typography variant="body">
          Your one-time verification code was sent by <strong>text message</strong> to
        </Typography>
        <Typography variant="bodyBold" mb={8}>+1 (•••) ••• - {phoneNumber.length === 10 ? phoneNumber.slice(6) : ''}</Typography>
        {pageError && <ErrorMessage>{pageError}</ErrorMessage>}
        <Input
          autoFocus
          label="Verification code"
          name="Verification"
          id="verify-code-field"
          type="text"
          bg="white"
          onChange={onVerifyChange}
          onKeyDown={onVerifyKeyDown}
          placeholder="Enter verification code"
          error={verificationCodeError}
          data-testid="code-input-test"
          isRequired
          value={verificationCode}
          maxLength={10}
          pattern="\\d{6}"
        />
        <Button
          isFullWidth
          data-testid="verify-code-button-test"
          mt={2}
          onClick={verifyCodeAction.act}
          disabled={verifyCodeAction.disabled}
          hidden={!verifyCodeAction.visible}
        >
          Verify Code
        </Button>
        <Button
          isFullWidth
          data-testid="cancel-button-test"
          mt={2}
          onClick={cancelAction.act}
          disabled={cancelAction.disabled}
          hidden={!cancelAction.visible}
          variant="ghost"
        >
          Cancel
        </Button>
        <Typography variant="body" mt={2} textAlign="center">
          Didn’t receive the text message?
          &nbsp;<Link
            href="#"
            // @ts-ignore
            onClick={sendANewCodeAction.act}
            data-testid="send-new-code-button-test"
          >
            click here to resend
          </Link>
        </Typography>
      </Flex>
    );
  } else if (phoneMethod === 'call') {
    return (
      <Flex direction="column" maxW={468} minH="100vh" justifyContent="center" mx="auto" data-testid="confirm-phone-factor-call-test">
        <Typography variant="h2">
          Check your phone
        </Typography>
        <Typography variant="body">
          You should receive a <strong>phone call</strong> soon at
        </Typography>
        <Typography variant="bodyBold">+1 (•••) ••• - {phoneNumber.length === 10 ? phoneNumber.slice(6) : ''}</Typography>
      </Flex>
    );
  }

  return (
    <Flex direction="column" maxW={468} minH="100vh" justifyContent="center" mx="auto" data-testid="confirm-phone-factor-empty-test">
    </Flex>
  );
}
